import type { RepertoireNode } from '../api/types';

/**
 * Status/contradiction banner signals (learning spec §7.4), derived from the
 * v1 §4 `RepertoireNode` aggregates. This is the single-node approximation; the
 * full cross-line contradiction query and nearest-node recovery land in Track 2.
 */

export type StatusKind = 'transposition' | 'branch' | 'contradiction';

export interface StatusItem {
  kind: StatusKind;
  text: string;
}

export function deriveStatusItems(node: RepertoireNode | null): StatusItem[] {
  if (node === null) return [];
  const items: StatusItem[] = [];

  if (node.incomingPathCount > 1) {
    items.push({
      kind: 'transposition',
      text: `Reached by ${node.incomingPathCount} move orders — a transposition.`,
    });
  }

  if (node.outgoing.length > 1) {
    items.push({
      kind: 'branch',
      text: `${node.outgoing.length} repertoire responses from this position.`,
    });
  }

  const prepped = node.outgoing.filter(
    (edge) => edge.enabled && (edge.role === 'main' || edge.role === 'alternative'),
  );
  if (prepped.length >= 2) {
    items.push({
      kind: 'contradiction',
      text: 'Multiple main/alternative moves are prepped for this position.',
    });
  }

  return items;
}
